const Match = require('@/tbs/model/to/Match')
const ClassFunc = require('@/tbs/util/ClassFunc')

const tbs_model_to_NewMatchDetail = function () {
  ClassFunc.super(this, Match, arguments)
}

//--------------------------------------------------
// prototype - 赛事详情页结构（tab 等），赛事场景文案在 Match
//--------------------------------------------------
tbs_model_to_NewMatchDetail.prototype = {
  'reg-status-1': '报名开始前',
  'reg-status-2': '报名中',
  'reg-status-3': '报名已结束',
  'home': '首页',
  'schedule': '赛程',
  'ranking': '榜单',
  'video': '视频',
  'team': '球队',
  'my': '我的',
}

//--------------------------------------------------
// extends the Match（赛事场景）
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_NewMatchDetail, Match)

module.exports = tbs_model_to_NewMatchDetail